import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['hasDangerousCargo', 'unField', 'unNoField', 'lithiumField', 'temperatureManagementRequired', 'designatedTemperature'];

  static values = { toChina: Boolean };

  connect() {
    this.changeDangerousHandler();
    this.changeTemperatureHandler();
  }

  changeDangerousHandler() {
    this.displayFields();
  }

  changeTemperatureHandler() {
    if (this.temperatureManagementRequiredTarget.checked) {
      this.designatedTemperatureTarget.classList.remove('hidden');
    } else {
      this.designatedTemperatureTarget.classList.add('hidden');
    }
  }

  displayFields() {
    if (this.hasDangerousCargoTarget.checked) {
      this.unFieldTarget.classList.remove('hidden');
      this.lithiumFieldTarget.classList.remove('hidden');

      if (this.toChinaValue) {
        this.unNoFieldTarget.classList.remove('hidden');
      } else {
        this.unNoFieldTarget.classList.add('hidden');
      }
    } else {
      this.unFieldTarget.classList.add('hidden');
      this.lithiumFieldTarget.classList.add('hidden');
    }
  }
}
